export function getRoot() {
  return process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://ezice.herokuapp.com";
}

export function numberWithCommas(x) {
  return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
